import React from 'react';
import { graphql } from 'gatsby';

import Pancake from './Pancake';
import Container from '../Container';
import PancakeIntro from '../PancakeIntro';
import JobsListing from '../JobsListing';

import './Jobs.scss';

const Jobs = (props) => {
  const { title, text, theme } = props;

  return (
    <Pancake className="PancakeJobs" theme={theme} id="careers">
      <Container>
        <PancakeIntro title={title} text={text} />

        <JobsListing />

        <div className="JobsBenefits">
          <div className="JobsBenefit">
            <h3 className="JobsBenefitTitle">Remote First</h3>
            <p className="JobsBenefitText">
              100% remote from day one means we understand what it takes to
              foster an efficient, distributed team across international
              timezones.
            </p>
          </div>
          <div className="JobsBenefit">
            <h3 className="JobsBenefitTitle">Unlimited PTO</h3>
            <p className="JobsBenefitText">
              3 weeks minimum encouraged, plus a full company week off in
              December.
            </p>
          </div>
          <div className="JobsBenefit">
            <h3 className="JobsBenefitTitle">Family Leave</h3>
            <p className="JobsBenefitText">
              16 weeks paid parental leave for birth, adoption and foster
              parents.
            </p>
          </div>
          <div className="JobsBenefit">
            <h3 className="JobsBenefitTitle">Health Benefits</h3>
            <p className="JobsBenefitText">
              100% medical, vision and dental coverage for employees and 50% for
              dependents.
            </p>
          </div>
          <div className="JobsBenefit">
            <h3 className="JobsBenefitTitle">Company Events</h3>
            <p className="JobsBenefitText">Sponsored yearly company offsite.</p>
          </div>
          <div className="JobsBenefit">
            <h3 className="JobsBenefitTitle">$1k WFH Stipend</h3>
            <p className="JobsBenefitText">
              Office equipment stipend to get you set up for work-from-home
              productive success.
            </p>
          </div>
        </div>
      </Container>
    </Pancake>
  );
};

export const query = graphql`
  fragment SanityPancakeJobs on SanityJobs {
    _key
    _type
    theme
    pancakeIntro {
      pancakeText
      pancakeTitle
    }
  }
`;

export default Jobs;
